import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { SerialUser } from 'src/app/core/models/serialUser.model';
import { SerialUserService } from 'src/app/core/services/serialUser.service';

import { User } from 'src/app/core/models/persons.model';
import { AuthService } from 'src/app/core/services/auth.service';
import { ToastService } from 'src/app/shared/widget/notification/toast-service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SerialEventsCount } from 'src/app/core/models/serialEventsCount.model';
import { SerialEventsCountService } from 'src/app/core/services/serialEventsCount.service';

@Component({
  selector: 'app-monitoring',
  templateUrl: './monitoring.component.html',
  styleUrls: ['./monitoring.component.scss'],
})
export class MonitoringComponent implements OnInit {
  user: User;
  serialUserList: SerialUser[] = [];
  circularProgressiveWait = false;
  circularProgressiveWait2 = false;
  serialUserNew: SerialUser = new SerialUser();
  serialUserUpdate: SerialUser = new SerialUser();
  serialEventsCount: SerialEventsCount[] = [];
  events: [{ event: string; seriais: string[] }] = [
    { event: '', seriais: [''] },
  ];
  eventsFilter: [{ event: string; seriais: string[] }] = [
    { event: '', seriais: [''] },
  ];
  dates: string[] = [];
  seriais: { id: number; serial: string }[] = [];
  seriaisListFilter: { id: number; serial: string }[] = [
    { id: -1, serial: 'Todos' },
  ];
  seriaisListSelectComponent: string[] = [];
  serialFilterSelect: number[] = [-1];

  constructor(
    private serialUserService: SerialUserService,
    private authService: AuthService,
    private toastService: ToastService,
    private modalService: NgbModal,
    private serialEventsCountService: SerialEventsCountService
  ) {
    this.user = this.authService.currentUserValue;
  }

  ngOnInit(): void {
    this.serialUserList = [];
    this.serialEventsCount = [];
    this.events = [{ event: '', seriais: [''] }];
    this.eventsFilter = [{ event: '', seriais: [''] }];
    this.dates = [];
    this.seriais = [];
    this.seriaisListSelectComponent = [];
    this.seriaisListFilter = [{ id: -1, serial: 'Todos' }];
    this.serialFilterSelect = [-1];
    this.circularProgressiveWait = true;
    this.serialUserNew.userId = this.user.userId;

    this.serialUserService.getSerialUser(this.user.userId).subscribe(
      (response) => {
        this.serialUserList = response;
        if (this.serialUserList.length > 0) {
          this.serialUserList.forEach((item: any) => {
            this.seriaisListSelectComponent.push(item.serial);
            this.seriaisListFilter.push({
              id: this.seriaisListFilter.length,
              serial: item.serial,
            });
          });
        }
        this.circularProgressiveWait = false;
      },
      (error: HttpErrorResponse) => {
        this.circularProgressiveWait = false;
        alert(error.message);
        this.toastService.show('Erro ao carregar tabela - ' + error.message, {
          classname: 'bg-danger text-center text-white',
          delay: 10000,
        });
      }
    );
  }

  searchEvents() {
    this.circularProgressiveWait2 = true;
    this.events = [{ event: '', seriais: [''] }];
    this.eventsFilter = [{ event: '', seriais: [''] }];
    this.dates = [];
    this.serialEventsCountService
      .runSerialEventsCount(this.user.userId)
      .subscribe(
        (r) => {
          this.serialEventsCountService
            .runSerialEventsCount(this.user.userId)
            .subscribe(
              (response) => {
                this.serialEventsCount = response;
                if (this.serialEventsCount.length > 0) {
                  this.serialEventsCount.forEach((item) => {
                    var indexEventInList = this.events.findIndex((event) => {
                      return event.event == item.event;
                    });
                    var existDateInList =
                      this.dates.findIndex((date) => {
                        return date == item.date;
                      }) == -1
                        ? false
                        : true;
                    var existSeriaisInList =
                      this.seriais.findIndex((serial) => {
                        return serial.serial == item.serial;
                      }) == -1
                        ? false
                        : true;
                    if (indexEventInList == -1) {
                      this.events.push({
                        event: item.event,
                        seriais: [item.serial],
                      });
                    } else {
                      let existSerialEvent =
                        this.events[indexEventInList].seriais.findIndex(
                          (serialEvent: any) => {
                            return serialEvent == item.serial;
                          }
                        ) > -1
                          ? true
                          : false;
                      if (!existSerialEvent) {
                        this.events[indexEventInList].seriais.push(item.serial);
                      }
                    }

                    if (!existDateInList) {
                      this.dates.push(item.date);
                    }
                    if (!existSeriaisInList) {
                      this.seriais.push({
                        id: this.seriais.length,
                        serial: item.serial,
                      });
                    }
                  });
                  try {
                    this.events = this.events.sort((obj1, obj2) => {
                      if (obj1.event > obj2.event) {
                        return 1;
                      } else if (obj1.event < obj2.event) {
                        return -1;
                      }
                      return 0;
                    });
                  } catch (error) {}
                }
                this.eventsFilter = this.events;
                this.eventsFilter.shift();
                this.circularProgressiveWait2 = false;
              },
              (error: HttpErrorResponse) => {
                this.circularProgressiveWait2 = false;
                alert(error.message);
                this.toastService.show(
                  'Erro ao carregar tabela - ' + error.message,
                  {
                    classname: 'bg-danger text-center text-white',
                    delay: 10000,
                  }
                );
              }
            );
        },
        (error: HttpErrorResponse) => {
          this.circularProgressiveWait2 = false;
          alert(error.message);
          this.toastService.show('Erro ao carregar tabela - ' + error.message, {
            classname: 'bg-danger text-center text-white',
            delay: 10000,
          });
        }
      );
  }

  insertNewSerial() {
    this.circularProgressiveWait = true;
    this.serialUserService.postInsertSerialUser(this.serialUserNew).subscribe(
      (response) => {
        this.toastService.show('Serial inserido com sucesso', {
          classname: 'bg-success text-center text-white',
          delay: 2500,
        });
        this.serialUserNew = new SerialUser();
        this.serialUserNew.userId = this.user.userId;
        this.ngOnInit();
      },
      (error: HttpErrorResponse) => {
        this.circularProgressiveWait = false;
        alert(error.message);
        this.toastService.show(
          'Erro ao carregar inserir serial - ' + error.message,
          {
            classname: 'bg-danger text-center text-white',
            delay: 10000,
          }
        );
      }
    );
  }

  updateSerialUser() {
    this.circularProgressiveWait = true;
    this.serialUserService
      .updateInsertSerialUser(this.serialUserUpdate, this.serialUserUpdate.id)
      .subscribe(
        (response: any) => {
          this.toastService.show('Serial atualizado com sucesso', {
            classname: 'bg-success text-center text-white',
            delay: 2500,
          });
          this.serialUserUpdate = new SerialUser();
          this.serialUserNew.userId = this.user.userId;
          this.ngOnInit();
        },
        (error: HttpErrorResponse) => {
          this.circularProgressiveWait = false;
          alert(error.message);
          this.toastService.show(
            'Erro ao atualizar serial - ' + error.message,
            {
              classname: 'bg-danger text-center text-white',
              delay: 10000,
            }
          );
        }
      );
  }

  deleteSerialUser(id: number) {
    this.circularProgressiveWait = true;
    this.serialUserService.deleteSerialUser(id).subscribe(
      (response) => {
        this.toastService.show('Serial excluido com sucesso', {
          classname: 'bg-success text-center text-white',
          delay: 2500,
        });
        this.ngOnInit();
      },
      (error: HttpErrorResponse) => {
        this.circularProgressiveWait = false;
        alert(error.message);
        this.toastService.show('Erro ao excluir serial - ' + error.message, {
          classname: 'bg-danger text-center text-white',
          delay: 10000,
        });
      }
    );
  }
  changeFilterSelect() {
    this.seriaisListSelectComponent = [];
    this.eventsFilter = [{ event: '', seriais: [] }];
    this.serialFilterSelect.forEach((item) => {
      this.seriaisListFilter.forEach((serialListItem: any) => {
        if (item == -1 || serialListItem.id == item) {
          var existSeriaisInList =
            this.seriaisListSelectComponent.findIndex((serial) => {
              return serial == serialListItem.serial;
            }) == -1
              ? false
              : true;
          if (!existSeriaisInList && serialListItem.serial != 'Todos') {
            this.seriaisListSelectComponent.push(serialListItem.serial);

            this.events.forEach((eventItem: any) => {
              let existEvent = this.eventsFilter.findIndex(
                (eventFilterItem: any) => {
                  return eventFilterItem.event == eventItem.event;
                }
              );
              if (existEvent == -1) {
                let existSerialEvent = eventItem.seriais.findIndex(
                  (eventItemSerialItem: any) => {
                    return eventItemSerialItem == serialListItem.serial;
                  }
                );
                if (existSerialEvent > -1) {
                  this.eventsFilter.push({
                    event: eventItem.event,
                    seriais: [''],
                  });
                }
              }
            });
          }
          return true;
        }
        return true;
      });
    });
    this.eventsFilter.shift();
    try {
      this.eventsFilter = this.eventsFilter.sort((obj1, obj2) => {
        if (obj1.event > obj2.event) {
          return 1;
        } else if (obj1.event < obj2.event) {
          return -1;
        }
        return 0;
      });
    } catch (error) {}
  }

  openModalUpdate(item: SerialUser, centerDataModal: any) {
    var serialUserUpdateAux = new SerialUser();
    serialUserUpdateAux = item;
    this.serialUserUpdate = serialUserUpdateAux;
    this.modalService.open(centerDataModal, {
      centered: true,
      windowClass: 'modal-holder',
    });
  }
  openModal(centerDataModal: any) {
    this.modalService.open(centerDataModal, {
      centered: true,
      windowClass: 'modal-holder',
    });
  }
}
